import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7t768kwdvz: FaireBrandEntity = {
  token: "b_7t768kwdvz",
  type: "brand",
  name: "HARANG",
  avatarUrl:
    "https://cdn.faire.com/fastly/a66e98451c2cadd9ef365330a8391b8197ce77eb14c76cbc19b5bc1993c4e2b6.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/dcd3459ff2e21984b55a45e723a526775a8e5ac0d5c24c3e4abf3a5914d6097e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a66e98451c2cadd9ef365330a8391b8197ce77eb14c76cbc19b5bc1993c4e2b6.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/dcd3459ff2e21984b55a45e723a526775a8e5ac0d5c24c3e4abf3a5914d6097e.jpeg",
  location: "Torrance, CA, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 14,
  isInsider: true,
  description:
    "Hello and welcome!\n“HARANG” is newly formed company that has operated print factory for long period of time. \nOur company was formed with long years of experience and skills. We prioritize maintaining strong trust from the customers and offering high quality t-shirts. Harang has all kinds of t-shirt designs that customers could imagine and are looking for. We’re currently following the modern technologies by using DTG machine. Our t-shirts offer multi-color designs along with comfortability when worn. DTG designs are printed using non-toxic vegan inks that ensure the garments are safe for adults, children, and babies up to 36 months. The ink that we use on our t-shirts are eco-friendly and has been award a part certification from Oeko-Tex for human ecological requirements.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:00.336Z",
    importedBy: "entity-db-cli",
  },
};
